// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"ac3e6e21","208":"d71f4110","315":"51d7732e","409":"b2d5af65","631":"12016215","771":"6bb1c57e","774":"59d74bcb","787":"ec78c514"}[chunkId] + ".chunk.js";
};